/**
 * Agent Proxy Context Menu Service
 *
 * Handles context menu actions for agent-proxy nodes in the Object Explorer.
 */

import type { AgentProxyNodeMetadata } from '../../explorer/models/nodeTypes';
import { openAgentWorkspace, deleteAgentObject } from './agentContextMenuHelper';

export function executeAgentProxyContextMenuAction(
  actionId: string,
  metadata: AgentProxyNodeMetadata,
  callbacks: { onRefresh: () => void },
) {
  const { connectionId, proxyName } = metadata;

  if (actionId === 'edit-proxy') {
    openAgentWorkspace(connectionId, 'proxies', { type: 'proxy', name: proxyName });
  } else if (actionId === 'delete-proxy') {
    void deleteAgentObject(
      connectionId, 'Proxy', proxyName,
      (args) => window.electronAPI?.jobScheduler?.deleteProxy(args) ?? Promise.resolve({ success: false, error: 'API not available' }),
      callbacks.onRefresh,
    );
  }
}
